<template>
  <el-row
    :gutter="12"
    :class="{ 'order-cancelled': pedidoAnulado }"
  >
    <el-col :span="1">{{ index + 1 }}</el-col>
    <el-col :span="4">{{
      pedido.ImportacionPedidoCantidad.ImportacionPedidoProducto.ImportacionPedido.CodigoPedido
    }}</el-col>
    <el-col :span="4">{{
      pedido.ImportacionPedidoCantidad.ImportacionPedidoProducto.CodigoProductoPedido
    }}</el-col>
    <el-col :span="4">{{ cantidad }}</el-col>
  </el-row>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  pedido: { type: Object, required: true },
  index: { type: Number, required: true },
});

const pedidoAnulado = computed(
  () => props.pedido.ImportacionPedidoCantidad.ImportacionPedidoProducto.Estado === 3,
);

const cantidad = computed(() => {
  if (pedidoAnulado.value) {
    return 'Pedido Anulado';
  }
  return props.pedido.ImportacionPedidoCantidad.Cantidad;
});
</script>

<style scoped>
.order-cancelled {
  background-color: #f56c6c;
  color: white;
}
</style>
